// extracted by mini-css-extract-plugin
export default {"offersListHeader":"offersListHeader_nOFok","title":"title_NuXLf","count":"count_dSc0s"};